import React from 'react';
import {connect} from 'react-redux';
import FaqsSectionEditPopup from './faqs_section_edit';
import {
    addFaqsToSite, removeFaqsForSite, sortSelectedFaqs,
    updateTitleFieldInTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup,
} from '../../sections/actions';
import {closeFaqsSectionPopup, updateFaqsSectionContents} from '../../actions';
import {clearFaqsSearchFilter} from '../../../faqs/actions';
import {onSearchFaqs} from '../../thunks';

class FaqsPopup extends React.Component {

    render() {
        return (
            <FaqsSectionEditPopup
                open={this.props.faqsSectionEditOpen}
                pageId={this.props.pageId}
                siteId={this.props.siteId}
                faqs={this.props.faqs}
                selectedFaqs={this.props.selectedFaqs}
                loading={this.props.loading}
                title={this.props.faqsSectionTitle}
                body={this.props.faqsSectionBody}
                onUpdateTitleField={
                    title => this.props.updateFaqsSectionTitleField(title)
                }
                onUpdateBodyField={
                    body => this.props.updateFaqsSectionBodyField(body)
                }
                onHandleSubmit={() => {
                    this.props.updateFaqsSectionContents(
                        this.props.pageId,
                        this.props.faqsSectionId,
                        this.props.sectionData,
                        this.props.selectedSettings
                    );
                    this.props.clearFaqsSearchFilter();
                }}
                onHandleClose={() => {
                    this.props.closeFaqsSectionPopup();
                    this.props.clearFaqsSearchFilter();
                }}
                searchCriteria={this.props.faqSearchCriteria}
                onSearchFaqs={this.props.onSearchFaqs}
                addFaqsToSite={this.props.addFaqsToSite}
                removeFaqsForSite={this.props.removeFaqsForSite}
                onSelectedFaqsSort={this.props.sortSelectedFaqs}
            />
        )
    }
}

const mapStateToProps = state => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    faqsSectionEditOpen: state.pageBuilder.faqsSectionPopup.open,
    faqsSectionTitle: state.pageBuilderSectionPopup.data.title,
    faqsSectionBody: state.pageBuilderSectionPopup.data.body,
    faqsSectionId: state.pageBuilderSectionPopup.sectionId,
    faqSearchCriteria: state.faqs.faqSearchCriteria,
    faqs: state.faqs.allFaqsBySearchTerms,
    selectedFaqs: state.pageBuilderSectionPopup.data.faqs,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(
    mapStateToProps, {
        updateFaqsSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateFaqsSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updateFaqsSectionContents: updateFaqsSectionContents,
        closeFaqsSectionPopup: closeFaqsSectionPopup,
        onSearchFaqs: onSearchFaqs,
        clearFaqsSearchFilter: clearFaqsSearchFilter,
        addFaqsToSite: addFaqsToSite,
        removeFaqsForSite: removeFaqsForSite,
        sortSelectedFaqs: sortSelectedFaqs
    }
)(FaqsPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/faqs_popup.js